var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"hljs",rawName:"v-hljs"}],staticClass:"markdown-body",domProps:{"innerHTML":_vm._s(_vm.source)}})}
var staticRenderFns = []

export { render, staticRenderFns }